import { ROLE_TYPE } from './types';
import useRequireRoles from './useRequireRoles';
import useRoles from './useRoles';

export const useIsAdmin = () => useRoles(ROLE_TYPE.ADMIN);
export const useRequireAdmin = () => useRequireRoles(ROLE_TYPE.ADMIN);
